import { render, staticRenderFns } from "./SearchHistory.vue?vue&type=template&id=8faa84c8&scoped=true&"
import script from "./SearchHistory.vue?vue&type=script&lang=js&"
export * from "./SearchHistory.vue?vue&type=script&lang=js&"
import style0 from "./SearchHistory.vue?vue&type=style&index=0&id=8faa84c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8faa84c8",
  null
  
)

export default component.exports